"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartPane = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const react_1 = __importStar(require("react"));
exports.ChartPane = react_1.default.forwardRef((props, ref) => {
    const { style, loading = false, width = 'auto', height = 'auto', children } = props, otherProps = __rest(props, ["style", "loading", "width", "height", "children"]);
    const flexWidth = width === 'auto';
    const flexHeight = height === 'auto';
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Pane_1.default, Object.assign({ center: true, ref: ref }, otherProps, { style: Object.assign(Object.assign({}, style), { overflow: 'auto', width: flexWidth ? '100%' : width, maxWidth: flexWidth ? 800 : width, minWidth: flexWidth ? undefined : width, height: flexHeight ? '100%' : height, maxHeight: flexHeight ? 800 : height, minHeight: flexHeight ? undefined : height }) }),
            loading && react_1.default.createElement(Dots_1.default, { style: { margin: 'auto' }, color: lib_palette_1.default.LavendarGrey }),
            !loading && children));
    }, [ref, otherProps, style, flexWidth, flexHeight, width, height, loading, children]);
});
exports.default = exports.ChartPane;
